if (!customElements.get('shop-the-look-cart-toggle')) {
  const instances = new Set();
  let syncPromise = null;
  let shouldResync = false;

  const updateInstances = (cart) => {
    instances.forEach((instance) => {
      instance.sync(cart);
    });
  };

  const requestCartSync = async () => {
    if (!instances.size) {
      return;
    }

    if (syncPromise) {
      shouldResync = true;
      return syncPromise;
    }

    syncPromise = fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        updateInstances(cart);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        syncPromise = null;

        if (shouldResync) {
          shouldResync = false;
          requestCartSync();
        }
      });

    return syncPromise;
  };

  document.addEventListener('ajaxProduct:added', requestCartSync);
  document.addEventListener('cart:update', requestCartSync);

  customElements.define('shop-the-look-cart-toggle', class ShopTheLookCartToggle extends HTMLElement {
    constructor() {
      super();

      this.productId = Number(this.dataset.productId);
      this.quickBuy = null;
      this.openCart = null;
    }

    connectedCallback() {
      this.quickBuy = this.querySelector('[data-quick-buy]');
      this.openCart = this.querySelector('[data-open-cart]');

      if (!this.productId || !this.quickBuy || !this.openCart) {
        return;
      }

      instances.add(this);
      requestCartSync();
    }

    disconnectedCallback() {
      instances.delete(this);
    }

    sync(cart) {
      const items = Array.isArray(cart?.items) ? cart.items : [];
      const inCart = items.some((item) => Number(item.product_id) === this.productId && item.quantity > 0);

      this.quickBuy.classList.toggle('hidden', inCart);
      this.openCart.classList.toggle('hidden', !inCart);
    }
  });
}
